<template>
    <div class="container-fluid-grid">
        <div class="row">
            <div class="col-12">
                <label>Habilitado o recebimento de notificações?</label>
                <div class="checkbox-inline" style="padding: 5px">
                    <label>
                        <input type="checkbox"
                               v-model="status"
                               @change="changeStatus"
                               :checked="notificationStatus === 'granted'"
                               class="checkbox green m"/><b :class="{'c-theme': status, 'c-red': !status}"> {{notificationStatus === "granted" ? 'Sim' : 'Não'}}</b></label>
                </div>
                <small>Veja mais como funciona as permissões de notificação clicando <a href="https://support.google.com/chrome/answer/3220216?co=GENIE.Platform%3DDesktop&hl=pt-br" target="_blank" class="link-theme">aqui</a>.</small>
            </div>
        </div>

    </div>
</template>

<script>
    import {startFirebase} from "../../utils/FirebaseApp";

    export default {
        name: "NotificationTab",
        data() {
            return {
                status: Notification.permission === 'granted',
                notificationStatus: Notification.permission
            }
        },
        methods: {
            changeStatus() {
                if (this.status) {
                    Notification.requestPermission()
                        .then(async result => {
                            if (result === 'denied') {
                                this.$snotify.warning('Você optou por bloquear todas notificações. É necessário debloquear pelo navegador.', this.$appStorage.getUser().name);
                            }

                            this.status = result === 'granted';
                            this.notificationStatus = result;

                            if (this.status) {
                                setTimeout(startFirebase, 2000);
                            }
                        })
                        .catch(err => {
                            this.status = false;
                            console.error('Permissão Erro', err);
                            this.$snotify.warning('Aconteceu algum problema ao tentar permitir notificações.', this.$appStorage.getUser().name);
                        });
                } else if (Notification.permission === 'granted') {
                    this.$snotify.info('Para parar de receber notificações é necessário debloquear pelo navegador.', this.$appStorage.getUser().name);
                    setTimeout(() => this.status = true, 500);
                }
            }
        }
    }
</script>

<style scoped>

</style>
